<template>
    <div class="chat-content-wrapper knd-wrapper knd-m-auto knd-my-5">
        <div class="chat-content knd-flex knd-flex-col" ref="chat">
            <Message
                v-for="(item, index) in content.chat_repeater"
                :key="index"
                :message="item"
                :data-index="index"
                class="knd-chat__item"
                :delay="Number(item.delay)"
                :wait="Number(item.wait)"
                :show="item.show"
                @created="handleCreate(index)"
            >
            </Message>
        </div>
    </div>
</template>
    
    <script>
        import enterView from 'enter-view';
        import Message from './chatMessage.vue';
    
        export default {
            components:{Message},
            props: {
                content: {
                    type: Object
                },
                simulate: {
                    type: Boolean,
                    default: true
                },
                credits: {
                    type: Number
                }
            },
            data: function() {
                let data = Array.from(this.content.chat_repeater);
    
                return {
                    items: data,
                }
            },
            mounted () {
                if(!this.simulate) {
                    // this.items.forEach(d => d.show = true);
                    return;
                }
                this.setEnterView();
            },
    
            methods: {
                setEnterView() {
                    let el = this.$refs.chat;
                    let items = el.querySelectorAll('.knd-chat__item');
    
                    enterView({
                    selector: items,
                    enter: (el) => {
                        el.classList.add('entered');
                        let index = +el.dataset.index;
                        if(!this.items[index]) return;
                        this.items[index].show = true;
                    },
                    exit: function(el) {
                        el.classList.remove('entered');
                    },
                    offset: 0.3, // enter at middle of viewport
                    once: true, // trigger just once
                    });
                },
    
                async handleCreate(index) {
                    if(this.items[index].profile[0].titel === 'user' && this.simulate) {
                        this.$store.dispatch('creditsSubtract');
                    }
                }
            },
        }
    </script>
    
    <style lang="scss">
    </style>